var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLetterpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8037_225393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4523 69.0283C82.4523 77.7655 68.4923 84.7819 51.1773 84.7819C33.8624 84.7819 19.9023 77.7049 19.9023 69.0283H82.4523Z",
    fill: "#231F20",
    stroke: "white",
    strokeWidth: 1.23,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.452 64.5684C82.452 73.3055 68.5347 80.4431 51.2481 80.4431C33.9616 80.4431 19.9731 73.354 19.9731 64.6168L82.452 64.5684Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.23,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2498 91.5076H85.5941C84.4853 90.2958 83.5755 89.2779 82.623 88.2963C79.0943 84.6366 74.8878 81.493 70.1699 78.9896C69.189 78.4806 68.9899 77.9959 69.6012 77.1597C70.2125 76.3236 70.6674 75.4268 71.2645 74.421C81.7274 79.547 89.0628 87.036 94.9055 95.9429H1.08057C6.76693 86.927 14.0313 79.3895 24.5795 74.2393L26.9535 78.1049C20.3026 81.4772 14.6006 86.0523 10.2498 91.5076V91.5076Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8225 19.7796L35.6963 9.39437L39.4209 6.52237L44.6381 11.3696L45.2494 11.0909C45.2494 10.6425 45.3631 10.1942 45.3631 9.75792C45.3631 7.23734 45.3631 4.71677 45.3631 2.19619C45.3631 1.32368 45.6759 0.984375 46.7847 0.984375C47.8935 0.984375 49.1019 0.984375 50.4808 0.984375V10.9455L50.9215 11.1515L56.6932 6.30424L60.0055 9.38225L47.8225 19.7796Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1031 23.7793H55.8827C55.8827 26.2029 55.968 28.6266 55.8827 31.0502C55.8827 32.3953 56.2097 32.8437 57.8729 32.8073C61.8818 32.6983 65.9049 32.8073 69.9138 32.8073C70.4824 32.8073 71.0511 32.8073 71.8187 32.88C71.8187 33.9464 71.8187 34.928 71.8187 35.8974C71.8998 39.6701 71.7527 43.4439 71.378 47.2037C69.9565 57.3345 58.5837 65.0295 46.5997 64.2782C40.4882 64.0062 34.7375 61.7281 30.5529 57.9216C26.3683 54.115 24.0747 49.0754 24.1528 43.8591C24.1528 40.6235 24.1528 37.3759 24.1528 34.1646C24.1528 33.0618 24.5793 32.7831 25.7876 32.7952C29.8107 32.7952 33.8196 32.7952 37.8285 32.7952C40.0888 32.7952 40.0888 32.7952 40.0888 30.929L40.1031 23.7793ZM66.6015 37.388C66.4369 37.3069 66.2599 37.2457 66.0755 37.2062H30.2941C29.4127 37.2062 29.2563 37.5819 29.2563 38.212C29.2563 40.466 29.171 42.72 29.2563 44.9618C29.4873 48.4844 31.0862 51.8414 33.8013 54.5042C36.5164 57.1671 40.1933 58.9844 44.2532 59.6702C48.313 60.356 52.5251 59.8712 56.2262 58.2921C59.9274 56.7131 62.9072 54.1295 64.6966 50.9482C67.2554 46.5129 66.502 41.9686 66.6015 37.388ZM50.566 28.2145H45.2066C45.2066 29.5718 45.2066 30.8563 45.2066 32.1408C45.2066 32.3589 45.6046 32.7346 45.8321 32.7346C47.3816 32.7952 48.9311 32.7346 50.5375 32.7346L50.566 28.2145Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6015 37.3873C66.502 41.968 67.2554 46.5608 64.7534 50.9112C62.9641 54.0925 59.9842 56.6761 56.2831 58.2551C52.582 59.8342 48.3699 60.319 44.31 59.6332C40.2502 58.9475 36.5732 57.1301 33.8582 54.4672C31.1431 51.8044 29.5442 48.4474 29.3132 44.9248C29.171 42.683 29.3132 40.429 29.3132 38.175C29.3132 37.5449 29.4696 37.1571 30.3509 37.1692H66.1324C66.2993 37.2241 66.457 37.2975 66.6015 37.3873V37.3873Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8037_225393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterpress);
export default __webpack_public_path__ + "static/media/letterpress.ec97dab5.svg";
export { ForwardRef as ReactComponent };